<style>

/* *{
  border: 1px red solid;
} */

.container{
  display: grid;
  grid-template-columns: 18% auto 18%;
  /* grid-template-rows: 300px; */
  align-items: center;
  /* height: 300px; */
}
.hour{
  grid-column: 1;
  grid-row: 1;
  min-height: 300px;
}
.time{
  grid-column: 2;
  grid-row: 1;
  text-align: center;
  font-size: 40px;
}
.minute{
  grid-column: 3;
  grid-row: 1;
  text-align: right;
  min-height: 300px;
}

.hour-message{
  grid-column: 1;
  grid-row: 2;
  /* text-align: left; */
}
.minute-message{
  grid-column: 3;
  grid-row: 2;
  /* text-align: right; */
}

</style>

<!-- 
[|] [time] [|]
-->
 
<div class="container">
  <div class="hour">
    <RangeSlider id="hour-slider" min="{-23}" max="{0}" pips bind:values="{hour}" springValues="{ { stiffness: 0.25, damping: 0.9 } }" vertical="{true}" on:change="{parseFromNegative}"></RangeSlider>
  </div>
  <div class="time">{displayTime}</div>
  <div class="minute">
    <RangeSlider id="minute-slider" min="{-55}" max="{0}" pips bind:values="{minute}" springValues="{ { stiffness: 0.25, damping: 0.9 } }" vertical="{true}" step="{5}" on:change="{parseFromNegative}"></RangeSlider>
  </div>
  <div class="hour-message small">hour</div>
  <div class="minute-message small">min</div>
</div>

<script>

import DateTime from "../helpers/DateTime.js";

import RangeSlider from "svelte-range-slider-pips";

export let time = "16:20:00";

// because the slider operates highest value at the 
// bottom of the slider (we want it the opposite),
// we use negative numbers and then parse it back
// to positive numbers
let hour = [0];
let minute = [0];
let displayTime = "";
let once = false;

$:{
  if (time) parseTime(time);
}


function parseTime(time) {
  
  if (once == true) return;
  
  let dt = DateTime.splitDate("1976-02-29 " + time);
  let date = new Date(dt.year, dt.month, dt.date, dt.hour, dt.minutes, dt.seconds);
  
  hour[0] = 0 - date.getHours();
  minute[0] = 0 - date.getMinutes();
  
  // console.log("hour[0]:", hour[0]);
  // console.log("minute[0]:", minute[0]);
  
  parseFromNegative();
  
  once = true;
}


// because the slider operates highest value at the 
// bottom of the slider (we want it the opposite),
// we use negative numbers and then parse it back
// to positive numbers
function parseFromNegative() {
  let thour = 0 - hour[0];
  let tminute = 0 - minute[0];
  
  let ohour = "";
  let ohour24 = "";
  let ominute = "";
  let operiod = "";
  
  if (thour > 12) {
    ohour = (thour - 12).toString();
  } else if (thour == 0) {
    ohour = "12";
  } else {
    ohour = thour.toString();
  }
  
  ohour24 = thour.toString();
  if (thour < 10) ohour24 = `0${ thour.toString() }`;
  
  if (tminute < 10) {
    ominute = `0${ tminute.toString() }`;
  } else {
    ominute = tminute.toString();
  }
  
  if (thour >= 12) {
    operiod = "pm";
  } else {
    operiod = "am";
  }
  
  displayTime = `${ohour}:${ominute} ${operiod}`;
  time = `${ohour24}:${ominute}:00`;
}


</script>